import axios from "axios";
import queryString from "query-string";

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// Utils
import { calculateSalePrice } from "../../utils/salePrices.js";

export const categoriesAreLoading = () => {
	return {
		type: "CATEGORIES_ARE_LOADING"
	};
};

export const categoriesHasError = bool => {
	return {
		type: "CATEGORIES_HAS_ERROR",
		hasErrored: bool
	};
};

export const categoriesSuccess = data => {
	return {
		type: "CATEGORIES_SUCCESS",
		data
	};
};

export const unloadCategory = () => {
	return {
		type: "CATEGORY_UNLOAD"
	};
};

export function getCategories(permalink, sort, sort_order, pg) {
	return dispatch => {
		dispatch(categoriesAreLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		// axios.defaults.headers.common['Authorization'] = siteKey

		const args = {
			order_by: sort,
			sort_order: sort_order,
			pg: pg
		};

		const qs = queryString.stringify(args);

		return axios
			.get(REACT_APP_API_URL + "category/" + permalink + "?" + qs, { headers: AUTH_HEADER })
			.then(response => dispatch(categoriesSuccess(response)))
			.catch(err => {
				console.log("getCategories error:", err.response.statusText);
				dispatch(categoriesHasError(err.response.statusText));
			});
	};
}

// ===================================================================================
//  SORT
// ===================================================================================
export const setSortedCategory = (sortedItems, index) => {
	return {
		type: "CATEGORY_SORT",
		sortedItems,
		index
	};
};

export function sortCategories(value, dir, index) {
	return (dispatch, getState) => {
		let products = [].concat(getState().category.categories[index].results.items);
		products.sort((a, b) => {
			let valueA = a[value];
			let valueB = b[value];

			// If title sorted, ignore case
			if (value === "title") {
				valueA = a[value].toUpperCase();
				valueB = b[value].toUpperCase();

				// If price sorted, determine if a sale price is used
			} else if (value === "price") {
				valueA = determineItemSalePrice(a);
				valueB = determineItemSalePrice(b);
			}

			if (dir === "asc") {
				return valueA > valueB;
			} else {
				return valueA < valueB;
			}
		});

		dispatch(setSortedCategory(products, index));
		return Promise.resolve();
	};
}

const determineItemSalePrice = product => {
	// If there are no sale prices
	if (!product.prices.length) {
		return product.price;
	} else {
		// Return sale price
		return Object.keys(product.prices).map((priceKey, i) => {
			const priceItem = product.prices[priceKey];
			return calculateSalePrice(product.price, priceItem.price, priceItem.price_type);
		});
	}
};



// WEBPACK FOOTER //
// ./src/store/actions/category.js